export const createSmallCanvas = (source, smallCanvasSize) => {
  const smallCanvas = document.createElement("canvas");
  const ctx = smallCanvas.getContext("2d");
  smallCanvas.width = smallCanvasSize.w;
  smallCanvas.height = smallCanvasSize.h;

  ctx.drawImage(source, 0, 0, smallCanvas.width, smallCanvas.height);

  return smallCanvas;
};
